import { Patient } from 'src/models';
import { SearchedPatient, useGetPatientList } from 'src/hooks/patient';
import { Select } from 'antd';
import { SearchOutlined, LoadingOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { formatStaticDate } from 'src/utils';

type PatientOption = {
  label: SearchedPatient['patient_Name'];
  value: SearchedPatient['patient_id'];
} & SearchedPatient;

type PatientDropdownProps = {
  showSearch?: boolean;
  onChange: (
    patient: SearchedPatient['patient_id'],
    option?: PatientOption | PatientOption[]
  ) => void;
  value: Patient['patient_id'] | undefined;
};

const PatientDropdown = ({ onChange, value }: PatientDropdownProps) => {
  const [search, setSearch] = useState('');
  const {
    data: patients,
    isLoading,
    isFetching,
  } = useGetPatientList({
    search,
  });

  return (
    <Select
      value={value}
      className="min-w-[200px] font-normal"
      placeholder="Search patient"
      allowClear
      showSearch
      prefix={
        isLoading || isFetching ? (
          <LoadingOutlined className="text-gray-400" />
        ) : (
          <SearchOutlined className="text-gray-400" />
        )
      }
      optionRender={(patient) => {
        const { patient_Name, patient_id, patient_birth_date } =
          patient?.data || {};
        return (
          <div className="flex flex-col">
            <div className="font-medium">{patient_Name}</div>
            <div className="text-sm text-gray-500">
              {patient_id} • {formatStaticDate(patient_birth_date)}
            </div>
          </div>
        );
      }}
      filterOption={() => {
        // Filtering is already taken care by the useGetPatientList hook
        return true;
      }}
      onSearch={setSearch}
      disabled={isLoading}
      options={patients?.map((patient) => ({
        label: patient.patient_Name,
        value: patient.patient_id,
        ...patient,
      }))}
      onChange={onChange}
    />
  );
};

export { PatientDropdown };
